// 各平台得分卡 mock 数据
// 维度进度条配色（与 3.1/3.2 口径一致）
const C_BCR = '#4F8EF7'
const C_IA = '#4096FF'
const C_SS = '#1677FF'
const C_MRR = 'var(--geo-red)'
const C_CWR = 'var(--geo-orange)'
const C_SOV = 'var(--geo-green)'

// 推荐品牌徽标/标签配色（金/蓝/红/浅蓝四套）
const GOLD = {
  badgeBg: '#F59E0B',
  chipBg: 'rgba(245,158,11,.1)',
  chipBorder: '1px solid rgba(245,158,11,.3)',
}
const BLUE = {
  badgeBg: '#1677FF',
  chipBg: 'rgba(22,119,255,.10)',
  chipBorder: '1px solid rgba(22,119,255,.24)',
}
const RED = {
  badgeBg: '#FF4D4F',
  chipBg: 'rgba(255,77,79,.10)',
  chipBorder: '1px solid rgba(255,77,79,.24)',
}
const LBLUE = {
  badgeBg: '#4096FF',
  chipBg: 'rgba(64,150,255,.10)',
  chipBorder: '1px solid rgba(64,150,255,.24)',
}

export const mockPlatforms = [
  { // DeepSeek
    name: 'DeepSeek', org: '深度求索 R1 / V3', stripeColor: '#4F8EF7',
    score: '19', scoreClass: 'low' as const, denom: '/100',
    pillKind: 'red' as const, pillLabel: '品牌空白',
    bars: [
      { label: 'BCR 25%', value: '11', barWidth: '11%', barColor: C_BCR },
      { label: 'IA 15%', value: '32', barWidth: '32%', barColor: C_IA },
      { label: 'SS 15%', value: '46', barWidth: '46%', barColor: C_SS },
      { label: 'MRR 20%', value: '8', barWidth: '8%', barColor: C_MRR },
      { label: 'CWR 15%', value: '12', barWidth: '12%', barColor: C_CWR },
      { label: 'SoV 10%', value: '10', barWidth: '10%', barColor: C_SOV },
    ],
    featureText: '当前平台表现特征：BCR得分最高（11），偶发提及GT7，但推荐优先度不足，主要推荐小米SU7和极氪001',
    recTitle: '该平台优先推荐 Top 3',
    recommendations: [
      { rank: '1', name: '小米SU7', ...GOLD },
      { rank: '2', name: '极氪001', ...BLUE },
      { rank: '3', name: '智界S7', ...RED },
    ],
  },
  { // 腾讯元宝
    name: '腾讯元宝', org: '腾讯', stripeColor: '#1677FF',
    score: '18', scoreClass: 'low' as const, denom: '/100',
    pillKind: 'red' as const, pillLabel: '品牌空白',
    bars: [
      { label: 'BCR 25%', value: '11', barWidth: '11%', barColor: C_BCR },
      { label: 'IA 15%', value: '28', barWidth: '28%', barColor: C_IA },
      { label: 'SS 15%', value: '44', barWidth: '44%', barColor: C_SS },
      { label: 'MRR 20%', value: '7', barWidth: '7%', barColor: C_MRR },
      { label: 'CWR 15%', value: '11', barWidth: '11%', barColor: C_CWR },
      { label: 'SoV 10%', value: '9', barWidth: '9%', barColor: C_SOV },
    ],
    featureText: 'BCR与DeepSeek并列最高，但频繁将GT7与智界S7/享界S9混淆，IA偏低，华为标签归属错误',
    recTitle: '该平台优先推荐 Top 3',
    recommendations: [
      { rank: '1', name: '小米SU7', ...GOLD },
      { rank: '2', name: '智界S7', ...RED },
      { rank: '3', name: '极氪001', ...BLUE },
    ],
  },
  { // 通义千问
    name: '通义千问', org: '阿里巴巴 Qwen', stripeColor: '#4096FF',
    score: '17', scoreClass: 'low' as const, denom: '/100',
    pillKind: 'red' as const, pillLabel: '品牌空白',
    bars: [
      { label: 'BCR 25%', value: '6', barWidth: '6%', barColor: C_BCR },
      { label: 'IA 15%', value: '30', barWidth: '30%', barColor: C_IA },
      { label: 'SS 15%', value: '48', barWidth: '48%', barColor: C_SS },
      { label: 'MRR 20%', value: '5', barWidth: '5%', barColor: C_MRR },
      { label: 'CWR 15%', value: '10', barWidth: '10%', barColor: C_CWR },
      { label: 'SoV 10%', value: '8', barWidth: '8%', barColor: C_SOV },
    ],
    featureText: 'SS情感得分相对最高（48），对GT7叙述整体中性、以客观描述为主，但品牌认知弱，推荐场景几乎缺席',
    recTitle: '该平台优先推荐 Top 3',
    recommendations: [
      { rank: '1', name: '极氪001', ...BLUE },
      { rank: '2', name: '蔚来ET5T', ...LBLUE },
      { rank: '3', name: '小米SU7', ...GOLD },
    ],
  },
  { // 豆包
    name: '豆包', org: '字节跳动', stripeColor: '#F59E0B',
    score: '14', scoreClass: 'low' as const, denom: '/100',
    pillKind: 'red' as const, pillLabel: '品牌空白',
    bars: [
      { label: 'BCR 25%', value: '5', barWidth: '5%', barColor: C_BCR },
      { label: 'IA 15%', value: '25', barWidth: '25%', barColor: C_IA },
      { label: 'SS 15%', value: '43', barWidth: '43%', barColor: C_SS },
      { label: 'MRR 20%', value: '3', barWidth: '3%', barColor: C_MRR },
      { label: 'CWR 15%', value: '8', barWidth: '8%', barColor: C_CWR },
      { label: 'SoV 10%', value: '6', barWidth: '6%', barColor: C_SOV },
    ],
    featureText: '各维度偏低，在推荐场景中几乎不提及GT7，IA准确率最低之一，参数混淆严重',
    recTitle: '该平台优先推荐 Top 3',
    recommendations: [
      { rank: '1', name: '小米SU7', ...GOLD },
      { rank: '2', name: '极氪001', ...BLUE },
      { rank: '3', name: '蔚来ET5T', ...LBLUE },
    ],
  },
  { // 文心一言
    name: '文心一言', org: '百度 ERNIE Bot', stripeColor: '#E91E8C',
    score: '12', scoreClass: 'low' as const, denom: '/100',
    pillKind: 'red' as const, pillLabel: '品牌空白',
    bars: [
      { label: 'BCR 25%', value: '4', barWidth: '4%', barColor: C_BCR },
      { label: 'IA 15%', value: '22', barWidth: '22%', barColor: C_IA },
      { label: 'SS 15%', value: '40', barWidth: '40%', barColor: C_SS },
      { label: 'MRR 20%', value: '2', barWidth: '2%', barColor: C_MRR },
      { label: 'CWR 15%', value: '7', barWidth: '7%', barColor: C_CWR },
      { label: 'SoV 10%', value: '5', barWidth: '5%', barColor: C_SOV },
    ],
    featureText: '缺席程度严重，品牌词几乎无法触发，信息准确率最低（22分），存在将GT7归入广汽昊铂的混淆',
    recTitle: '该平台优先推荐 Top 3',
    recommendations: [
      { rank: '1', name: '极氪001', ...BLUE },
      { rank: '2', name: '智界S7', ...RED },
      { rank: '3', name: '蔚来ET5T', ...LBLUE },
    ],
  },
  { // Kimi
    name: 'Kimi', org: '月之暗面 Moonshot', stripeColor: '#10B981',
    score: '11', scoreClass: 'low' as const, denom: '/100',
    pillKind: 'red' as const, pillLabel: '品牌空白',
    bars: [
      { label: 'BCR 25%', value: '3', barWidth: '3%', barColor: C_BCR },
      { label: 'IA 15%', value: '18', barWidth: '18%', barColor: C_IA },
      { label: 'SS 15%', value: '38', barWidth: '38%', barColor: C_SS },
      { label: 'MRR 20%', value: '2', barWidth: '2%', barColor: C_MRR },
      { label: 'CWR 15%', value: '5', barWidth: '5%', barColor: C_CWR },
      { label: 'SoV 10%', value: '4', barWidth: '4%', barColor: C_SOV },
    ],
    featureText: '所有平台中GEO最低，BCR=3几乎完全空白，IA=18信息极度匮乏，推荐场景全面缺席',
    recTitle: '该平台优先推荐 Top 3',
    recommendations: [
      { rank: '1', name: '极氪001', ...BLUE },
      { rank: '2', name: '蔚来ET5T', ...LBLUE },
      { rank: '3', name: '小米SU7', ...GOLD },
    ],
  },
]